import {createAction} from 'redux-actions';
import {getQcReportsStatuses} from '@pluto/rest/lib/rest';
import {QCReportStatusEnum} from '../QCReportsStatusesTypes';

export const QC_REPORTS_STATUSES_SET = 'QC_REPORTS_STATUSES_SET';
export type QCReportsStatusesPayload = QCReportStatusEnum[];

export const setQcReportsStatusesAction = createAction<Promise<QCReportsStatusesPayload>>(QC_REPORTS_STATUSES_SET, async () => {
    return getQcReportsStatuses();
});
